import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Automation, UsersQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/users`
const AUTOMATION_URL = `${API_URL}/automations`

const getAutomations = (query: string, companyId : String): Promise<UsersQueryResponse> => {
  return axios
    .get(`${AUTOMATION_URL}?${query}`)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getSingleAutomation = (id: ID): Promise<Automation | undefined> => {
  return axios
    .get(`${AUTOMATION_URL}/${id}`)
    .then((response: AxiosResponse<Response<Automation>>) => response.data)
    .then((response: Response<Automation>) => response.data)
}

const createAutomations = (automationData: any, companyId : String, timezone : any): Promise<Automation | undefined> => {
  automationData.hostname = `${API_URL}`;
  automationData.companyID = companyId;
  automationData.timezone = timezone;
  return axios
    .post(`${AUTOMATION_URL}`, automationData)
    .then((response: AxiosResponse<Response<Automation>>) => response.data)
    .then((response: Response<Automation>) => response.data)
}



const updateAutomation = (user: Automation, id : any, companyId : string, timezone: any): Promise<Automation | undefined> => {
  user.timezone = timezone;
  return axios
    .patch(`${AUTOMATION_URL}/${id}`, user)
    .then((response: AxiosResponse<Response<Automation>>) => response.data)
    .then((response: Response<Automation>) => response.data)
}

const updatePassword = (user: Automation): Promise<Automation | undefined> => {
  
  return axios
    .post(``, user)
    .then((response: AxiosResponse<Response<Automation>>) => response.data)
    .then((response: Response<Automation>) => response.data)
}

const deleteAutomation = (automationId: ID): Promise<void> => {
  return axios.delete(`${AUTOMATION_URL}/${automationId}`).then(() => {})
}



const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getAutomations, deleteAutomation, deleteSelectedUsers, getSingleAutomation, createAutomations,updateAutomation,updatePassword}
